import React, { FC } from 'react';
import styles from './LPUniqueSellingPointText.module.scss';

export interface LPUniqueSellingPointTextProps {
  text: string;
}

const LPUniqueSellingPointText: FC<LPUniqueSellingPointTextProps> = ({ text: __html }) => {
  return (
    <div className={styles.uniqueSellingPoint}>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html }} />
    </div>
  );
};

export default LPUniqueSellingPointText;
